<template>
    <div>
        <div class="header clearfix">
              <span class="nav_menu" @click="navOpen">
                <i></i>
              </span>
            <p>{{title}}</p>
        </div>
        <mt-popup
                style="width: 240px;height:100%;background: rgb(249,249,249);"
                v-model="popupVisible"
                position="left">
            <div class="user-info">
                <div v-if="userNo">
                    <p>{{companyName}}</p>
                    <p>账号：{{userNo}}</p>
                    <p>{{role}}</p>
                </div>
                <div v-else>
                    <p @click="pushRouterName('Login', {companyNo: $route.query.companyNo})">去登录</p>
                </div>
            </div>

            <div class="menu-wrap">
                <div class="menu">
                    <ul>
                        <li v-for="(item,index) in navList" :key="index" @click="pushRouterName(item.routerName)">
                            {{item.navName}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="logout" @click="logout()" v-if="userNo">
                <p>退出登录</p>
            </div>
        </mt-popup>
    </div>
</template>
<script>
    export default {
        props: {
            title: String
        },
        data() {
            return {
                popupVisible: false,
                userNo: '',
                companyName: '',
                role: '',
                navList: [
                    {navName: '首页', routerName: 'Main'},
                    {navName: '订单查询', routerName: 'OrderQuery'},
                    {navName: '运单查询', routerName: 'WaybillQuery'},
                    {navName: '轨迹查询', routerName: 'Transfer'},
                    {navName: '报价查询', routerName: 'Price'},
                    {navName: '问题件', routerName: 'Problem'},
                    {navName: '账单查询', routerName: 'Bill'},
                    {navName: '余额查询', routerName: 'Balance'},
                    {navName: '偏远查询', routerName: 'Remote'},
                ],
            }
        },
        created() {
            let companyNo = this.$util.get("companyNo");
            let userInfo = this.$util.get(companyNo+"_userInfo");
            if (!userInfo) {
                this.navList = [];
                return false;
            }
            this.userNo = userInfo.userNo;
            this.companyName = userInfo.companyName;
            this.role = userInfo.role;
            let accountType = userInfo.accountType;
            if (accountType == 0) { // 员工账号
                this.navList = [
                    {navName: '首页', routerName: 'Main'},
                    {navName: '订单查询', routerName: 'OrderQuery'},
                    {navName: '报价查询', routerName: 'Price'},
                    {navName: '问题件', routerName: 'Problem'},
                    {navName: '偏远查询', routerName: 'Remote'},
                ]
            }
        },
        methods: {
            navOpen() {
                this.popupVisible = true;
            },
            pushRouterName(routerName, query) {
                this.$router.push({name: routerName, query});
            },
            logout() {
                this.http.send({
                    command: 'rWeixinClient/unbindingByWechatNo',
                    params: {loginType: 1}
                }).then(res => {
                    if (res.data.result_code == 0) {
                        let companyNo = this.$util.get('companyNo');
                        this.$util.cookieClear();
                        this.$router.replace({name: 'Login', query: {companyNo: companyNo}});
                    }
                }).catch(err => {
                    this.$util.cookieClear();
                    this.$router.replace({name: 'Login', query: {companyNo: companyNo}});
                    alert(err);
                })
            }
        }
    }
</script>
<style scoped>
    .header {
        background-color: #286ed6;
        color: #fff;
        text-align: center;
        height: 80px;
        line-height: 80px;
        padding: 0 15px;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 2;
    }
    .header p {
        font-size: 22px;
    }
    .nav_menu {
        display: inline-block;
        position: absolute;
        background: #fff;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        top: 25px;
        left: 15px;
        line-height: 23px;
        text-align: center;
    }
    .nav_menu i {
        display: inline-block;
        height: 3px;
        background: #286ed6;
        width: 16px;
        position: relative;
    }
    .nav_menu i:before {
        content: '';
        width: 16px;
        height: 3px;
        background: #286ed6;
        display: inline-block;
        position: absolute;
        top: -6px;
        left: 0;
    }
    .nav_menu i:after {
        content: '';
        width: 16px;
        height: 3px;
        background: #286ed6;
        display: inline-block;
        position: absolute;
        top: 6px;
        left: 0;
    }
    .user-info {
        height: 170px;
        background-color: #286ed6;
        color: #fff;
        text-align: center;
        background-image: url("../../assets/por.png");
        background-repeat: no-repeat;
        background-size: 60px auto;
        background-position: center 20px;
        padding-top: 90px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 22px;
    }
    .menu-wrap {
        position: absolute;
        left:0;
        right:0;
        bottom:52px;
        top: 170px;
        overflow-y: auto;
        background: #fff;
    }
    .menu {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 30px;
    }
    .menu li {
        list-style: none;
        line-height: 40px;
        color: #333;
        font-size: 15px;
    }
    .logout {
        text-align: center;
        color: #ff3f3f;
        font-size: 15px;
        padding-top: 16px;
        position: absolute;
        width: 100%;
        bottom: 0;
        padding-bottom: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/headerNav/index.vue